import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader.js";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry.js";

const donuts = [];
const fontLoader = new FontLoader();
fontLoader.load("/fonts/font.json", (font) => {
  const textGeometry = new TextGeometry("Retto's Blog", {
    font: font,
    size: 0.5,
    depth: 0.1,
    curveSegments: 4,
    bevelEnabled: true,
    bevelThickness: 0.03,
    bevelSize: 0.01,
    bevelOffset: 0,
    bevelSegments: 4,
  });
  textGeometry.computeBoundingBox();
  textGeometry.center();
  const material = new THREE.MeshMatcapMaterial({
    matcap: matcapTexture,
  });
  const text = new THREE.Mesh(textGeometry, material);
  scene.add(text);

  const donutMaterialList = [];
  for (let i = 0; i < 9; i++) {
    const material = new THREE.MeshMatcapMaterial({
      matcap: textTextureList[i],
    });
    donutMaterialList.push(material);
  }

  donutMaterialList.push(material);

  const donutGeometry = new THREE.TorusGeometry(0.3, 0.2, 20, 45);

  for (let i = 0; i < 100; i++) {
    const ran = parseInt(Math.random() * 9);
    const donut = new THREE.Mesh(donutGeometry, donutMaterialList[ran]);

    const radius = 1.5 + Math.random() * 4.5;
    const angle = Math.random() * Math.PI * 2;
    donut.userData.orbit = {
      radius,
      angle,
      speed: Math.random() * 0.4,
      y: (Math.random() - 0.5) * 3,
      y_range: Math.random() * 0.5,
      y_speed: Math.random() * 0.4,
    };
    donut.userData.spin = {
      x: (Math.random() - 0.5) * 2,
      y: (Math.random() - 0.5) * 2,
      z: (Math.random() - 0.5) * 2,
    };

    donut.position.x = Math.cos(angle) * radius;
    donut.position.y = donut.userData.orbit.y;
    donut.position.z = Math.sin(angle) * radius;

    donut.rotation.x = Math.random() * Math.PI;
    donut.rotation.y = Math.random() * Math.PI;
    const scale = Math.random();
    donut.scale.set(scale, scale, scale);

    scene.add(donut);
    donuts.push(donut);
  }
});

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader();
const textTextureList = [];
const matcapTexture = textureLoader.load("/textures/matcaps/9.png");
for (let i = 0; i < 9; i++) {
  textTextureList.push(textureLoader.load(`/textures/matcaps/${i + 1}.png`));
  textTextureList[i].colorSpace = THREE.SRGBColorSpace;
}
matcapTexture.colorSpace = THREE.SRGBColorSpace;

/**
 * Object
 */
// const cube = new THREE.Mesh(
//   new THREE.BoxGeometry(1, 1, 1),
//   new THREE.MeshBasicMaterial()
// );

// scene.add(cube);

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  100
);
camera.position.x = 1;
camera.position.y = 1;
camera.position.z = 2;
scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Animate
 */
const clock = new THREE.Clock();
let previousTime = 0;

const tick = () => {
  const elapsedTime = clock.getElapsedTime();
  const deltaTime = elapsedTime - previousTime;
  previousTime = elapsedTime;

  for (const donut of donuts) {
    const orbit = donut.userData.orbit;
    const angle = orbit.angle + orbit.speed * elapsedTime;

    donut.position.x = Math.cos(angle) * orbit.radius;
    donut.position.z = Math.sin(angle) * orbit.radius;
    donut.position.y =
      orbit.y + Math.sin(orbit.y_speed * elapsedTime) * orbit.y_range;

    const spin = donut.userData.spin;
    donut.rotation.x += spin.x * deltaTime;
    donut.rotation.y += spin.y * deltaTime;
    donut.rotation.z += spin.z * deltaTime;
  }

  // Update controls
  controls.update();

  // camera.lookAt(text);
  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();
